import React from 'react';
import ActionsBlock from './components/datatable/ActionsBlock';
import * as DatesUtils from '../../utils/dates';
import { Languages, AuthRoles } from '../../config';
import * as CurrencyUtils from '../../utils/currency';

const CONFIGURATION = {};

export default CONFIGURATION;

export const allowedActions = {
  add: {
    roles: [AuthRoles.User, AuthRoles.Agent],
  },
  edit: {
    state_status: ['0N'],
    roles: AuthRoles.Registered,
  },
  payment: {
    state_status: ['2A'],
    roles: [AuthRoles.Admin],
  },
};

const statusSelector = (status: string): string | null => {
  switch (status.toString()) {
    case '0':
      return 'Temporary';
    case '1':
      return 'Submited';
    case '2':
      return 'Processed';
    case '3':
      return 'Error';
    default:
      return '-';
  }
};

const stateSelector = (state: string): string | null => {
  switch (state) {
    case 'A':
      return 'Active';
    case 'N':
      return 'New';
    default:
      return null;
  }
};

export const TableColumns = [
  {
    label: '#',
    id: 'vat_return_id',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Ver. ID',
  //   id: 'vat_return_version_id',
  //   align: 'left',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'VAT Number',
    id: 'vat_id_num',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Version',
  //   id: 'version',
  //   align: 'left',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{DatesUtils.formatDateTime(cellValue)}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Period',
    id: 'quarter_id',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <React.Fragment>
        {data[rowIndex].year} - {data[rowIndex].short_text}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Submission Date',
    id: 'submission_date',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Status',
    id: 'vat_return_status_id',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              cellValue === 3 && data[rowIndex].vat_return_state === 'N'
                ? 'red'
                : cellValue === 1 && data[rowIndex].vat_return_state === 'N'
                ? 'orange'
                : 'black',
          }}
        >
          {statusSelector(cellValue)}/
          {stateSelector(data[rowIndex].vat_return_state)}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Taxable Amount',
    id: 'total_taxable_amount',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        € {CurrencyUtils.formatCurrency(cellValue ?? 0)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Amount',
    id: 'tax_amount',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        € {CurrencyUtils.formatCurrency(cellValue ?? 0)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Payable Amount',
    id: 'total_vat_amount_payable',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        € {CurrencyUtils.formatCurrency(cellValue ?? 0)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Allocated Amount',
    id: 'allocated_amount',
    align: 'left',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color:
              data[rowIndex].allocated_amount <
              data[rowIndex].total_vat_amount_payable
                ? 'red'
                : 'green',
            fontWeight: 'bold',
          }}
        >
          € {CurrencyUtils.formatCurrency(cellValue ?? 0)}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        status={data[rowIndex].vat_return_status_id}
        state={data[rowIndex].vat_return_state}
        is_sent={data[rowIndex].is_sent}
        vat_return_id={data[rowIndex].vat_return_id}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const TableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};

export const Translations = {
  add_vat_return: {
    [Languages.Greek]: 'Add VAT Return',
    [Languages.English]: 'Add VAT Return',
  },
  add_vat_return_payment: {
    [Languages.Greek]: 'Add Payment',
    [Languages.English]: 'Add Payment',
  },
  page_title: {
    [Languages.Greek]: 'VAT Returns',
    [Languages.English]: 'VAT Returns',
  },
  manage_vatreturns_title: {
    [Languages.Greek]: 'Manage Your One-Stop-Shop VAT Returns',
    [Languages.English]: 'Manage Your One-Stop-Shop VAT Returns',
  },
  manage_vatreturns_description: {
    [Languages.Greek]:
      'Review your One-Stop-Shop VAT Returns History from the list below. You can Update your previously submitted Processed VAT Returns from the list below, or Submit a new VAT Return using the "Add VAT Return" button on the right side of the header bar. Your Subitted Registration Form will go through the processign and approval procedure by the OSS Administration System.',
    [Languages.English]:
      'Review your One-Stop-Shop VAT Returns History from the list below. You can Update your previously submitted Processed VAT Returns from the list below, or Submit a new VAT Return using the "Add VAT Return" button on the right side of the header bar. Your Subitted Registration Form will go through the processign and approval procedure by the OSS Administration System.',
  },
  table_title: {
    [Languages.Greek]: 'VAT Returns Status and Update History',
    [Languages.English]: 'VAT Returns Status and Update History',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  vat_number_search_control: {
    [Languages.Greek]: 'VAT Number',
    [Languages.English]: 'VAT Number',
  },
  period_search_control: {
    [Languages.Greek]: 'Period',
    [Languages.English]: 'Period',
  },
  year_search_control: {
    [Languages.Greek]: 'Year',
    [Languages.English]: 'Year',
  },
  declaration_status_search_control: {
    [Languages.Greek]: 'Declaration Status',
    [Languages.English]: 'Declaration Status',
  },
  vat_return_status_search_control: {
    [Languages.Greek]: 'VAT Return Status',
    [Languages.English]: 'VAT Return Status',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dashboard',
    [Languages.English]: 'Go to dashboard',
  },
};
